import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";

import profileDefault from "../../../assets/images/profileDefault.png";
import TableColumn from "../../../components/TableColumn/TableColumn";
import api from "../../../services/api";
import TopNav from "../../../components/TopNav/TopNav";
import SideBar from "../../../components/SideBar/SideBar";
import chevronLeft from "../../../assets/images/icons/chevron-left.svg";
import { colors } from "../../../styles/tokens";

const ListFollowers = () => {
    const navigate = useNavigate();
    const { venueId } = useParams();

    const records = 10;

    const [listFollowers, setListFollowers] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        Number(localStorage.getItem("ListCurrentPageFollowers")) || 1
    );
    const [isLoading, setIsLoading] = useState(true);
    const [sortBy, setSortBy] = useState("firstName");
    const [sortDirection, setSortDirection] = useState("asc");

    const actions = [
        {
            label: <MdOutlineRemoveRedEye size={30} color={colors.primary} />,
            onClick: (rowData) => {
                navigate(`/users/${rowData._Id}`);
            },
        },
    ];

    const fetchData = async (page) => {
        if (!venueId) return;

        setIsLoading(true);
        try {
            const response = await api.get(`/venues/${venueId}/followers`, {
                params: {
                    page,
                    records,
                    sort_column: sortBy,
                    sort: sortDirection,
                },
            });

            const formattedData = response.data.data.map((follower) => ({
                Image: (
                    <img
                        className="rounded"
                        style={{ height: 40, width: 40, objectFit: "cover" }}
                        src={follower.photo_url || profileDefault}
                        alt="Follower"
                    />
                ),
                Name: follower.firstName,
                BirthDay: follower.birthday || "-",
                Location: follower.location || "-",
                Gender: follower.gender,
                _Id: follower._id,
            }));

            setListFollowers(formattedData);
            setTotalPages(response.data.total);
        } catch (error) {
            console.error("Error fetching followers:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage, sortBy, sortDirection, venueId]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem("ListCurrentPageFollowers", String(page));
    };

    const handleSort = (columnName) => {
        const backendColumn = sortColumnsMapping[columnName];
        if (sortBy === backendColumn) {
            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortBy(backendColumn);
            setSortDirection("asc");
        }
    };

    const columns = ["Image", "Name", "BirthDay", "Location", "Gender"];
    const sortableColumns = ["Name", "BirthDay", "Location"];

    const sortColumnsMapping = {
        Name: "firstName",
        BirthDay: "birthday",
        Location: "location",
    };

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />

                <article className="page-content">

                    <section
                        className="moderators"
                        style={{ width: "100%", maxWidth: "1550px" }}
                    >
                        <div>
                            {/* 👇 Followers title with arrow beside it */}
                            <TableColumn
                                title={
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                        }}
                                    >
                                        <img
                                            src={chevronLeft}
                                            onClick={() => navigate(-1)}
                                            alt="Back"
                                            style={{
                                                width: "20px",
                                                height: "20px",
                                                cursor: "pointer",
                                            }}
                                        />
                                        <span>Followers</span>
                                    </div>
                                }
                                records={records}
                                actions={actions}
                                columns={columns}
                                data={listFollowers}
                                sortableColumns={sortableColumns}
                                hasExport={false}
                                hasSearch={false}
                                hasHeader={true}
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onPageChange={(page) => {
                                    setIsLoading(true);
                                    setCurrentPage(page);
                                }}
                                onSort={handleSort}
                                isLoading={isLoading}
                            />
                        </div>
                    </section>
                </article>
            </div>
        </main>
    );
};

export default ListFollowers;
